import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { getRequest } from '../../globalhelper/helper'
import '../CI/COD.css'
import VR3_Forms from '../../pages/VR3_Form_Rendering/displayContainer'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import moment from 'moment/moment'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { CSVLink } from 'react-csv'
import { GetApp } from '@material-ui/icons'

const ExtendItemMaster = props => {
  const [state, setState] = useState({
    showtable: false,
    formData: {
      preferredvendor: '',
      itemname: '',
      itemid: '',
      status: '',
      orgname: '',
      period: null
    },
    tableData: [],
    filteredTableData: [],
    dropdown_preferredvendor: [],
    dropdown_itemname: [],
    dropdown_itemid: [],
    dropdown_status: [],
    extendJSON: [],
    dropdown_orgname: [],
    companyDetails: [],
    error: false,
    errorMessage: 'Please select all the required fields',
    createJSON: [],
    redirect: false
  })

  useEffect(() => {
    sessionStorage.setItem('pageName', 'Search ItemMaster')

    // Fetch item JSON for extension
    getRequest(`api/edureka/getItemJSONForExtension`).then(res => {
      console.log(res.res.data)
      setState(prev => ({
        ...prev,
        extendJSON: res.res.data,
        createJSON: res.res.data
      }))
    })

    // Fetch company data
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(response => {
        console.log(response.res.data)
        const responseData = response.res.data
        const arr = responseData.map(item => item.orgname)
        console.log(arr)
        if (arr?.length === 1) {
          handleChange('orgname', arr[0])
        }
        setState(prev => ({
          ...prev,
          dropdown_orgname: arr,
          companyDetails: responseData
        }))
      })
      .catch(err => console.log(err))

    // Fetch item Preferences data
    getRequest(`api/edureka/getIM1`).then(res => {
      let temp = JSON.parse(res.res.data)

      let temp1 = temp.map(value => value['Preferred Vendor'])
      let temp2 = temp1
        .filter(value => value)
        ?.sort((a, b) => a.localeCompare(b))

      let temp3 = temp.map(value => value['Item Name'])
      let temp4 = temp3.filter(value => value)
      let tem = [...new Set(temp4)]?.sort((a, b) => a.localeCompare(b))

      let temp7 = temp.map(value => value['Item ID'])
      let temp8 = temp7
        .filter(value => value)
        ?.sort((a, b) => a.localeCompare(b))

      setState(prev => ({
        ...prev,
        dropdown_preferredvendor: temp2,
        dropdown_itemname: tem,
        dropdown_itemid: temp8
      }))
    })
  }, [])

  useEffect(() => {
    if (!state.formData.period) return

    // if your period is '2025-10'
    const startDate = moment(state.formData.period, 'YYYY-MM').startOf('month')
    const endDate = moment(state.formData.period, 'YYYY-MM').endOf('month')

    const filtered = state.tableData.filter(item => {
      // parse with correct format (DD/MM/YYYY)
      const itemDate = moment(
        item?.['Created At'],
        [
          'YYYY-MM-DDTHH:mm:ss.SSSZ',
          'YYYY-MM-DD HH:mm:ss',
          'YYYY-MM-DD',
          'DD/MM/YYYY'
        ],
        true
      )
      return (
        (state.formData.state === 'EXTEND' &&
          !item['Preferences item ID'] &&
          itemDate.isSameOrAfter(startDate) &&
          itemDate.isSameOrBefore(endDate)) ||
        (state.formData.state === 'ALREADY EXTENDED' &&
          item['Preferences item ID'] &&
          itemDate.isSameOrAfter(startDate) &&
          itemDate.isSameOrBefore(endDate)) ||
        ((state.formData.state === '' ||
          state.formData.state === null ||
          state.formData.state === undefined) &&
          itemDate.isSameOrAfter(startDate) &&
          itemDate.isSameOrBefore(endDate)) ||
        false
      )
    })

    setState(prev => ({ ...prev, filteredTableData: filtered }))
  }, [state.formData.period, state.formData.state])

  const handleChange = (name, value) => {
    setState(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        [name]: value || ''
      }
    }))
  }

  const handleSearch = () => {
    const { orgname } = state.formData

    if (!orgname) {
      setState(prev => ({ ...prev, error: true }))
      return
    }

    setState(prev => ({ ...prev, error: false }))

    const { itemname, itemid } = state.formData
    const id = state.companyDetails.filter(item => item.orgname === orgname)
    console.log(id)
    const companyid = id.map(item => item.orgid)
    console.log(companyid)

    getRequest(
      `api/edureka/getExtendItemMasterData?itemname=${itemname}&itemid=${itemid}&orgid=${companyid[0]}`
    ).then(res => {
      if (res.res.status === 'success') {
        let temp = JSON.parse(res.res.data)
        console.log(temp)
        setState(prev => ({
          ...prev,
          tableData: temp,
          filteredTableData: temp,
          showtable: true
        }))
      } else {
        console.log('No Data')
      }
    })
  }

  const handleReset = () => {
    setState(prev => ({
      ...prev,
      showtable: false,
      error: false,
      formData: {
        preferredvendor: '',
        itemid: '',
        itemname: '',
        status: '',
        orgname: '',
        period: null
      }
    }))
  }

  const onBack = () => {
    setState(prev => ({
      ...prev,
      redirect: false,
      SearchJSON: []
    }))
  }

  const handleExtend = item => {
    const itemID = item['Item ID']
    const itemName = item['Item Name']
    console.log(itemID, itemName)

    const id = state.companyDetails.filter(
      item => item.orgname === state.formData.orgname
    )
    console.log(id)
    const companyid = id.map(item => item.orgid)
    console.log(companyid)

    const updatedJSONData = [...state.createJSON]
    const children = updatedJSONData[1].children[0].children

    const updateField = (title, value) => {
      const index = children.findIndex(item => item.title === title)
      if (index !== -1) {
        children[index].val = value
      }
    }

    updateField('Item Name', itemName)
    updateField('Item ID', itemID)
    updateField('Organization Name', state.formData.orgname)
    updateField('Organization ID', companyid[0])

    console.log(updatedJSONData)
    setState(prev => ({
      ...prev,
      extendJSON: updatedJSONData,
      redirect: true
    }))
  }

  const handleScreenRouting = item => {
    const orgID = item['Org ID']
    const preferredID = item['Preferences item ID']
    localStorage.setItem('api', `api/edureka/getUpdatedDataFromDB`);
    localStorage.setItem('apiParams', JSON.stringify({
      "LDE": {
        "Organization ID": orgID,
        "Item ID": preferredID
      },
      "Module": localStorage.getItem('module'),
      "screenName": "ItemPreferences"
    }))
    window.open(
      `/Dynamic_Forms?token=ItemPreferences&action=edit&orgId=${orgID}&docId=${preferredID}`,
      '_blank'
    )
    // getRequest(
    //   `api/edureka/getExtendJSONForItemPreference?lde1=${orgID}&lde2=${itemID}`
    // )
    //   .then(response => {
    //     console.log(response.res.data)
    //     setState(prev => ({
    //       ...prev,
    //       extendJSON: response.res.data,
    //       redirect: true
    //     }))
    //   })
    //   .catch(err => console.log(err))
  }

  if (state.redirect) {
    return (
      <VR3_Forms
        screenName={'ItemPreferences'}
        screenAction={'edit'}
        From_SearchJSON={state.extendJSON}
        onBack={onBack}
      />
    )
  }

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel3-content'
          id='panel3-header'
        >
          <Typography variant='h6'>Search Item Preferences</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete
                options={state.dropdown_orgname}
                value={
                  state.dropdown_orgname.find(
                    option => option === state.formData.orgname
                  ) || ''
                }
                onChange={(e, newValue) => handleChange('orgname', newValue)}
                renderInput={params => (
                  <TextField
                    name='orgname'
                    {...params}
                    label='Organization Name'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete
                options={state.dropdown_itemname}
                value={
                  state.dropdown_itemname.find(
                    option => option === state.formData.itemname
                  ) || ''
                }
                onChange={(e, newValue) => handleChange('itemname', newValue)}
                renderInput={params => (
                  <TextField
                    name='itemname'
                    {...params}
                    label='Item Name'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete
                options={state.dropdown_itemid}
                value={
                  state.dropdown_itemid.find(
                    option => option === state.formData.itemid
                  ) || ''
                }
                onChange={(e, newValue) => handleChange('itemid', newValue)}
                renderInput={params => (
                  <TextField
                    name='itemid'
                    {...params}
                    label='Item ID'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item md={1}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSearch}
              >
                Search
              </Button>
            </Grid>
            <Grid item md={1}>
              <Button
                style={{ marginLeft: 10 }}
                variant='contained'
                color='error'
                onClick={handleReset}
              >
                Reset
              </Button>
            </Grid>
            <Grid item md={1}>
              <Button
                style={{ marginLeft: 10 }}
                variant='contained'
                color='warning'
                onClick={() => props.onBack()}
              >
                Back
              </Button>
            </Grid>
          </Grid>
          {state.showtable && state.tableData.length > 0 && (
            <>
              <Typography variant='h6' mt={2} mb={2}>
                Filter
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={1} sm={2} md={2}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label='Period'
                      value={state.formData.period}
                      views={['month', 'year']}
                      onChange={newValue => {
                        handleChange('period', newValue)
                      }}
                      renderInput={params => (
                        <TextField fullWidth size='small' {...params} />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={1} sm={2} md={2}>
                  <Autocomplete
                    options={['EXTEND', 'ALREADY EXTENDED']}
                    value={state.formData.state || ''}
                    onChange={(e, newValue) => handleChange('state', newValue)}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label='State'
                        variant='outlined'
                        size='small'
                        fullWidth
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </AccordionDetails>
      </Accordion>

      <br />

      {state.showtable && state.tableData.length > 0 ? (
        <>
          <Box align='right'>
            <Button color='success' variant='contained'>
              <CSVLink
                style={{ color: 'white', textDecoration: 'none' }}
                data={state.tableData}
                filename='ItemPreferences.csv'
              >
                <GetApp />
              </CSVLink>
            </Button>
          </Box>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell>Item ID</TableCell>
                  <TableCell>Preferred Item ID</TableCell>
                  <TableCell>Item Name</TableCell>
                  <TableCell>Rate</TableCell>
                  <TableCell>Commodity Code</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Extend</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(state.filteredTableData.length > 0 &&
                  state.filteredTableData
                    .sort((a, b) => a['Item ID'].localeCompare(b['Item ID']))
                    .map((item, index) => (
                      <tr key={index}>
                        <TableCell>{item['Item ID']}</TableCell>
                        <TableCell>
                          <Button
                            variant='text'
                            color='primary'
                            onClick={() => handleScreenRouting(item)}
                            size='small'
                          >
                            {item['Preferences item ID']}
                          </Button>
                        </TableCell>
                        <TableCell>{item['Item Name']}</TableCell>
                        <TableCell>{item.Rate}</TableCell>
                        <TableCell>{item['Commodity Code']}</TableCell>
                        <TableCell>{item['Status']}</TableCell>
                        <TableCell>
                          {moment(item['Created At']).format('DD/MM/YYYY')}
                        </TableCell>
                        <TableCell>
                          <Button
                            size='small'
                            disabled={item['Preferences item ID']}
                            onClick={() => handleExtend(item)}
                            variant={'contained'}
                            color={
                              item['Preferences item ID']
                                ? 'info'
                                : 'success'
                            }
                          >
                            {item['Preferences item ID']
                              ? 'Already extended'
                              : 'Extend'}
                          </Button>
                        </TableCell>
                      </tr>
                    ))) || (
                    <TableRow>
                      <TableCell
                        colSpan={
                          state.tableData.length > 0 &&
                          Object.keys(state.tableData[0]).length
                        }
                        sx={{ p: 5 }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%'
                          }}
                        >
                          <Alert severity='error' variant='outlined'>
                            No matching records found. Please adjust your search criteria.
                          </Alert>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : null}

      {state.error && <div className='center-screen'>{state.errorMessage}</div>}
    </>
  )
}

const mapStateToProps = state => ({
  userData: state.login.userData
})

export default connect(mapStateToProps)(ExtendItemMaster)
